// src/design-system/components/Card/Card.tsx
import React from 'react';
import styles from './Card.module.css';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: 'default' | 'elevated' | 'outlined' | 'filled';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  hover?: boolean;
  glassmorphism?: boolean;
  className?: string;
}

interface CardSubComponentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> & {
  Header: React.FC<CardSubComponentProps>;
  Body: React.FC<CardSubComponentProps>;
  Footer: React.FC<CardSubComponentProps>;
} = ({
  children,
  variant = 'default',
  size = 'md',
  hover = false,
  glassmorphism = false,
  className = '',
  ...props
}) => {
  const stylesRecord = styles as Record<string, string>;
  const cardClasses = [
    stylesRecord['card'],
    stylesRecord[`card--${variant}`],
    stylesRecord[`card--${size}`],
    hover && stylesRecord['card--hover'],
    glassmorphism && stylesRecord['card--glassmorphism'],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
};

const CardHeader: React.FC<CardSubComponentProps> = ({ children, className = '', ...props }) => {
  const stylesRecord = styles as Record<string, string>;
  return (
    <div className={`${stylesRecord['cardHeader'] || ''} ${className}`} {...props}>
      {children}
    </div>
  );
};

const CardBody: React.FC<CardSubComponentProps> = ({ children, className = '', ...props }) => {
  const stylesRecord = styles as Record<string, string>;
  return (
    <div className={`${stylesRecord['cardBody'] || ''} ${className}`} {...props}>
      {children}
    </div>
  );
};

const CardFooter: React.FC<CardSubComponentProps> = ({ children, className = '', ...props }) => {
  const stylesRecord = styles as Record<string, string>;
  return (
    <div className={`${stylesRecord['cardFooter'] || ''} ${className}`} {...props}>
      {children}
    </div>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;

